import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a5ff946"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "show-box" }
const _hoisted_2 = { class: "show" }


import {TextAreaFieldType} from '@/components/business/crud/interface/FieldType';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer";
import { ColumnEdit } from '@/components/business/crud/widgets/TableWidgetContainer';


export default /*#__PURE__*/_defineComponent({
  __name: 'TextareaTable',
  props: {
    columnEdit: { type: Function },
    propName: {},
    widget: {},
    info: {},
    data: {}
  },
  setup(__props: any) {

const props = __props;

function ellipsis(text: string | undefined, max: number) {
  if (!text) {
    return "";
  }
  if (text.length <= max) {
    return text;
  } else {
    return text.slice(0, max - 3) + "..."
  }
}

function showLong(text: string | undefined, max: number) {
  if (!text) {
    return "";
  }
  if (text.length > max) {
    return text;
  }
}


return (_ctx: any,_cache: any) => {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_tooltip, {
      title: showLong(_ctx.data[_ctx.propName], 30),
      placement: "top"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, _toDisplayString(ellipsis(_ctx.data[_ctx.propName], 30)), 1)
      ]),
      _: 1
    }, 8, ["title"])
  ]))
}
}

})